/* ==========================================================================
   Fetch
   ========================================================================== */
/* Modules */
const { of } = require('rxjs');
const { catchError, switchMap } = require('rxjs/operators');

const { fromFetch } = require('rxjs/fetch');

/**
 * Api Fetch
 * @param {Object} instance - component instance
 * @param {String} url - Url endpoint
 * @param {string} controller - Controller name
 * @return {ReturnValueDataTypeHere} Observable fromFetch.
 */
function getService(instance, url, controller = 'fetch') {
    const inst = instance;
    const { controllers = {} } = instance;

    /* Cancel the previous request */
    if (controllers[controller] !== undefined) controllers[controller].abort();

    /* Feature detect */
    if ('AbortController' in window) inst.controllers = { ...controllers, [controller]: new AbortController() };

    return fromFetch(url, {
        signal: inst.controllers[controller].signal,
        credentials: 'same-origin',
        cache: 'no-store'
    }).pipe(
        switchMap(response => {
            if (response.ok) {
                return response.json();
            }
            return of({ error: true, errorCode: 666, message: `Error fetching ${response.statusText}` });
        }),
        catchError(err => of({ error: true, errorCode: err.code, message: err.message }))
    );
}

module.exports = {
    getService
};
